import React from 'react';

const LogReportIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 15C12.2833 15 12.521 14.904 12.713 14.712C12.905 14.52 13.0007 14.2827 13 14C12.9993 13.7173 12.9033 13.48 12.712 13.288C12.5207 13.096 12.2833 13 12 13C11.7167 13 11.4793 13.096 11.288 13.288C11.0967 13.48 11.0007 13.7173 11 14C10.9993 14.2827 11.0953 14.5203 11.288 14.713C11.4807 14.9057 11.718 15.0013 12 15ZM11 11H13V5H11V11ZM2 22V4C2 3.45 2.196 2.97933 2.588 2.588C2.98 2.19667 3.45067 2.00067 4 2H20C20.55 2 21.021 2.196 21.413 2.588C21.805 2.98 22.0007 3.45067 22 4V16C22 16.55 21.8043 17.021 21.413 17.413C21.0217 17.805 20.5507 18.0007 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z'
        fill='#6B7280'
      />
    </svg>
  );
};

export default LogReportIcon;
